<template>
  <v-progress-circular
    v-if="isCancelling"
    indeterminate
    color="primary"
    size="36"
    class="mx-auto"
  />
  <template v-else>
    <v-btn
      @click="close"
      variant="outlined"
      data-cy="cancelSubscriptionCloseButton"
      class="text-black"
      size="default"
    >
      {{ $t('buttons.close') }}
    </v-btn>
    <v-spacer />
    <v-btn
      @click="cancelSubscriptionConfirm"
      class="bg-error text-white"
      variant="text"
      data-cy="cancelSubscriptionConfirmButton"
    >
      {{ $t('subscriptionCancel.cancelCard.actionButton') }}
    </v-btn>
  </template>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { FusionStores } from '@fusion/saas-components-v3'
import { HTTPStatus } from '@/api'
import { MessageType, SNACKBAR_STATIC_DURATION_MS } from '@/services/notifications'
import { NAMESPACES } from '@/store/types'
import { SUBSCRIPTIONS_ACTIONS } from '@/store/subscriptions'

interface SnackbarMessage {
  text: string
  type: MessageType
  timeout: number
}

export default defineComponent({
  name: 'SubscriptionCancelActions',
  setup() {
    const notifications = FusionStores.notifications()
    return { notifications }
  },
  props: {
    activationId: {
      type: String,
      default: ''
    }
  },
  emits: ['close'],
  data() {
    return {
      isCancelling: false
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    async cancelSubscriptionConfirm(): Promise<void> {
      this.isCancelling = true
      const resp = await this.$api.patchCancelSubscription(this.activationId)
      let message: SnackbarMessage
      if (resp.status === HTTPStatus.OK) {
        message = {
          text: this.$t('subscriptionCancel.cancelCard.toasts.cancelSuccess'),
          type: MessageType.SUCCESS,
          timeout: SNACKBAR_STATIC_DURATION_MS
        }
        await this.$store.dispatch(
          `${NAMESPACES.SUBSCRIPTIONS}/${SUBSCRIPTIONS_ACTIONS.UPDATE_SUBSCRIPTIONS}`,
          {
            auth: this.$auth,
            api: this.$api,
            devices: this.$auth.isAuthenticated ? this.$store.state.devices.allDevices : []
          }
        )
      } else {
        message = {
          text: this.$t('subscriptionCancel.cancelCard.toasts.cancelFailure'),
          type: MessageType.ERROR,
          timeout: SNACKBAR_STATIC_DURATION_MS
        }
      }
      this.isCancelling = false
      this.notifications.addMessage(message)
      this.close()
    }
  }
})
</script>
